<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid
      .column.is-widescreen-5.is-desktop-6
        .u-mb-mi
          AppImg(:srcset="[{ srcset: '{CDN_URL}/ventures/tsro@2x.webp 2x, {CDN_URL}/ventures/tsro.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/tsro@2x.jpg 2x, {CDN_URL}/ventures/tsro.jpg 1x', type: 'image/jpg' }]" ratio="3:2")
      .column.is-widescreen-5.is-desktop-6
        .content.u-mb-xs
          div(v-html="$t('content')")
        AppLink(to="https://www.behance.net/gallery/79423083/Tsro-Brand-Identity-Design" :title="$t('cta')" class="button-link  " v-html="$t('cta')")


  .u-mb-md

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Tsro",
    "pageDesc":"Tsro is Baianat POS for restaurants and cafes. The system connects the store front with the kitchen operations.",
    "mantra":"Tsro point |of sale.",
    "content":"<p>Tsro offers a smart POS (point of sale system) for restaurants and cafes. It provides more options such as stock management, business reporting, integrated payments and automatic restock. </p><p>Business owners can view analytics and record customers activity to welcome them back through loyalty program. Tsro is not only about simple and easy to use POS, but we give our users the ability to have their custom storefront in the form of app, downloadable on their customer’s phones so they can order directly through it. The software is downloadable for free, also there's a mobile app for easy access to employees and cloud based version of the system. </p><p>The experienced lovely chef Tsro will help you with your business hassle and will answer all your questions anytime!. The character was designed to be fat friendly chef, implying expertise, coziness, elegance and helpfulness. </p><p>The chef will help you manage your restaurant system, orders, supply chain, also manage your employees and more. He's fun and friendly as close to your favorite typical chef with humble kind eyes and heavy body because of course, he loves to eat.</p><p>Tsro will be launched by early 2020 and you can check its brand identity and leave us your comments on Behance.</p>",
    "cta":"Brand identity"
  },
  "ar": {
    "pageTitle":"تسرو",
    "pageDesc":"تسرو هو حلول لنقاط البيع من أجل المطاعم والمقاهي وهو أحد مشاريع بيانات الداخلية، حيث يربط النظام واجهة المتجر مع عمليات المطبخ.",
    "mantra":"تسرو حلول |لنقاط البيع. ",
    "content":"<p>يقدم تسرو نظام نقاط البيع الذكي (POS) للمطاعم والمقاهي حيث يوفر المزيد من الخيارات مثل إدارة المخزون وتقارير الأعمال والمدفوعات المتكاملة وإعادة التخزين التلقائي. </p><p>يمكن لأصحاب الأعمال التجارية عرض التحليلات وتسجيل نشاط العملاء للترحيب بهم مرة أخرى من خلال برنامج الولاء. لا يقتصر تطبيق تسرو على نقاط البيع البسيطة وسهلة الاستخدام، لكننا نمنح مستخدمينا القدرة على الحصول على واجهة مخصصة لهم في شكل تطبيق يمكن تحميله على هواتفهم ليتمكنوا من الطلب مباشرة من خلاله. البرنامج متوفر للتحميل مجانًا، وهناك تطبيق للجوال يسهل الوصول إلى الموظفين. </p><p>سوف يساعدك الشيف تسرو ذو الخبرة على حل مشكلاتك التجارية وسوف يجيب على جميع أسئلتك في أي وقت. تم تصميم شخصية تسرو ليكون طباخ بدين ودود، مما يدل على الخبرة والراحة والأناقة والمساعدة. </p><p>سيساعدك الشيف في إدارة نظام المطعم والأوامر وسلسلة التوريد وإدارة موظفيك ...وغيرها. إنه وودود وسيكون بالقرب من رئيس الطهاة الخاص بك. </p><p>سيتم إطلاق تسرو في أوائل 2020 ويمكنك التحقق من تصميم العلامة التجارية على بيهانس.</p>",
    "cta":"تصميم العلامة التجارية"
  }
}
</i18n>
